import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AppConfig, CMPS_APP_CONFIG } from '../app.config';
import { catchErrorLogRet, mapRetrieve } from '../common/rest.operators';
import { ChatCategory } from '../teams-call/chat-menu/teamschat-summary/model/chat-category.model';

import { CommitmentChat } from './general';

@Injectable()
export class ChatService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    create(chat: CommitmentChat): Observable<number> {
        return this._http
            .post(`${this._appConfig.API_ENDPOINTS.COACHING}/chats`, chat)
            .pipe(mapRetrieve(), catchErrorLogRet(null));
    }

    list(
        commitmentId?: number,
        chatId?: number,
        expandChat?: boolean,
        expandCommitment?: boolean,
    ): Observable<CommitmentChat[]> {
        let params = new HttpParams();
        if (commitmentId != null) {
            params = params.set('commitmentId', String(commitmentId));
        }
        if (chatId != null) {
            params = params.set('chatId', String(chatId));
        }
        if (expandChat != null) {
            params = params.set('expandChat', expandChat);
        }
        if (expandCommitment != null) {
            params = params.set('expandCommitment', expandCommitment);
        }
        return this._http
            .get(`${this._appConfig.API_ENDPOINTS.COACHING}/chats`, { params })
            .pipe(mapRetrieve(), catchErrorLogRet(null));
    }

    listChatSummary(userId: number): Observable<ChatCategory[]> {
        const params = new HttpParams().set('userId', String(userId ?? null));
        return this._http
            .get(`${this._appConfig.API_ENDPOINTS.COACHING}/chats/summary`, {
                params,
            })
            .pipe(mapRetrieve(), catchErrorLogRet(null));
    }
}
